import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { LeagueRegPopupComponent } from 'src/app/league-reg-popup/league-reg-popup.component';
import { GamepreviewpopupComponent } from 'src/app/gamepreviewpopup/gamepreviewpopup.component';

@Component({
  selector: 'app-lague-invite',
  templateUrl: './league-invite.component.html',
  styleUrls: ['./league-invite.component.scss']
})
export class LeagueInviteComponent implements OnInit {

  assetURL:String;
  parameters:any;
  
  leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>;
  gamePreviewDialogRef: MatDialogRef<GamepreviewpopupComponent>

  constructor(@Inject(MAT_DIALOG_DATA) private popupData,public dialog: MatDialog, private dialogRef: MatDialogRef<LeagueInviteComponent>) {
    this.parameters = popupData;
  }

  ngOnInit() {
    this.assetURL = `${environment.assetURL}`;
  }

  closePopup(){
    this.dialogRef.close(1);
  }

  viewSetting(){
    window.location.href = `${environment.SITE_URL}`+'/league/settings/nhl/'+this.parameters.league_code;
  }

  acceptInvitation(){
      this.leagueDialogRef = this.dialog.open(LeagueRegPopupComponent, {
        width: '500px',
        data: { 'league_code': this.parameters.league_code, 'draft_type': 'league' }
      });
  
      this.leagueDialogRef.afterClosed()
      .subscribe(res => {
         if (res) { 
          this.dialogRef.close(1); 
          this.gamePreviewDialogRef.close(1); 
         }
      }) 
  }

}
